import ky from 'ky'
import { z } from 'zod'

import { CompanySchema, TermSchema } from '@/web-components/BapFormApp/BapFormSchema'
import queryString from 'query-string'

export const wpQueryApiBase = `${window.location.origin}/wp-json/wp/v2`

type queryParameters = {
  per_page?: number
  orderby?: 'title' | 'id'
  order?: 'asc' | 'desc'
}
type wpQueryBaseParameters = {
  query?: queryParameters
}
type wpQueryId = {
  id: number
}

export type getTermQuery = {
  termId: number
  path: companyTaxonomy
  query?: queryParameters
}

export const wpQuery = {
  getCompany: async (params: wpQueryBaseParameters & wpQueryId) => {
    const response = await apiCall({
      path: 'company',
      id: params.id,
      query: params.query,
    })
    const data = CompanySchema.parse(response)
    return data
  },
  getCompanies: async (params?: Pick<companyQuery, 'query'>) => {
    const response = await apiCall({
      path: 'company',
      query: { orderby: 'title', per_page: 100, ...params?.query },
    })
    const data = z.array(CompanySchema).parse(response)
    return data
  },
  getCompaniesByTerm: async (params: companiesByTaxonomyQuery) => {
    const response = await apiCall({
      path: 'company',

      query: { per_page: 150, ...params.query },
    })
    const data = z.array(CompanySchema).parse(response)
    return data
  },
  getCompanyTaxonomies: async (
    params: wpQueryBaseParameters & Pick<companyTaxonomiesQuery, 'path'>
  ) => {
    const response = await apiCall({
      path: params.path,
      query: { per_page: 100, ...params.query },
    })
    const data = z.array(TermSchema).parse(response)
    return data
  },
  getTerm: async (params: getTermQuery) => {
    const response = await apiCall({
      path: params.path,
      id: params.termId,
      query: params.query,
    })
    const data = TermSchema.parse(response)
    return data
  },
}

export type companyType = 'bap_company' | 'yp_company'
type companyQuery = {
  path: 'company'
  id?: number
  query?: {
    meta_key?: companyType
    meta_value?: string | boolean
  } & queryParameters
}

export type companyTaxonomy = 'bap_category' | 'yp_category'
type companyTaxonomiesQuery = {
  path: companyTaxonomy
  id?: number
  query?: queryParameters
}

type companiesByTaxonomyQuery = {
  path: 'company'
  id?: number
  query: {
    bap_category?: number
    yp_category?: number
  } & queryParameters
}
type apiCallProps = companyQuery | companyTaxonomiesQuery | companiesByTaxonomyQuery

async function apiCall(params: apiCallProps) {
  try {
    const url = [wpQueryApiBase, params.path, params.id].join('/')

    const queries: queryParameters = {
      // per_page: 100,
      // orderby: 'title',
      // order: 'asc',
      ...params.query,
    }
    const requestUrl = queryString.stringifyUrl({ url: url, query: queries })
    // console.log(requestUrl)

    // console.log(requestUrl)
    const response = await ky.get(requestUrl).json()
    return response
  } catch (error) {
    if (error instanceof Error) {
      throw new Error(`Error in 'apiCall(${wpQueryApiBase})': ${error.message}`)
    }

    throw new Error(`Error in 'apiCall(${wpQueryApiBase})': ${JSON.stringify(error)}`)
  }
}
